export default __webpack_public_path__ + "static/media/File No. 17.7f36b250.pdf";